"use client";

import { useEffect } from "react";
import { analyticsEventForLink, trackEvent } from "@/lib/analytics";

function closestAnchor(target: EventTarget | null): HTMLAnchorElement | null {
  return target instanceof Element ? target.closest("a[href]") : null;
}

export function ConversionTracking() {
  useEffect(() => {
    function onClick(event: MouseEvent) {
      const anchor = closestAnchor(event.target);
      if (!anchor) return;
      const href = anchor.getAttribute("href") ?? "";
      const analyticsEvent = analyticsEventForLink(href, anchor.textContent ?? "");
      if (!analyticsEvent) return;
      trackEvent(analyticsEvent.name, {
        ...analyticsEvent.params,
        page_path: window.location.pathname,
      });
    }

    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
